import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { ref: "content" }
const _hoisted_2 = { class: "row gy-2" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['transition',{'pretty-block': _ctx.opened}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['pretty_button','d-flex','justify-content-between','align-items-center','m-0','p-2',{'active': _ctx.opened,'mb-2': _ctx.opened}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPanel()))
    }, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.filter.name), 1),
      _createElementVNode("div", null, [
        _createElementVNode("i", {
          class: _normalizeClass({dropdown_arrow:1,dropped_down: _ctx.opened})
        }, null, 2)
      ])
    ], 2),
    _createElementVNode("div", {
      style: _normalizeStyle({height: _ctx.height + 'px',transition: 'all .2s ease-in-out'}),
      class: "overflow-hidden"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.values, (value) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12",
              key: value.code
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(['pretty_button','m-0','w-100',{'active': _ctx.filter.optionChecked(value)}]),
                onClick: ($event: any) => (_ctx.checkOption(_ctx.filter,value))
              }, _toDisplayString(value.name), 11, _hoisted_3)
            ]))
          }), 128))
        ])
      ], 512)
    ], 4)
  ], 2))
}